<template>
  <div>
    <div class="row">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">IndexPage</el-breadcrumb-item>
        <el-breadcrumb-item>Item</el-breadcrumb-item>
        <el-breadcrumb-item>Trade</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="row filter">

      <div class="filter-item clear">
        <div class="item-head ">
          <span>Trade:</span>
        </div>
        <div class="item-content">
          <el-input v-model="filter.tradeName" placeholder=""></el-input>
        </div>
      </div>
    </div>

    <div class="row">
      <el-button type="primary" @click.native="process">Query</el-button>
      <el-button type="primary" @click.native="form.dialogFormVisible = true">New</el-button>
    </div>

    <div class="row">
      <template>
        <el-table
          :data.sync="records"
          stripe
          border
          @sort-change="sortChange"
          style="width: 100%">
          <el-table-column
            prop="tradeId"
            label="ID"
            width="70">
          </el-table-column>
          <el-table-column
            prop="tradeName"
            label="TRADE"
            sortable="custom"
            min-width="200">
          </el-table-column>

          <el-table-column
            prop="priority"
            label="Priority"
            sortable="custom"
            min-width="50"
          ></el-table-column>

          <el-table-column
            prop="createAt"
            label="CREATE"
            sortable="custom"
            min-width="70">
          </el-table-column>

          <el-table-column
            label="OPERATIONS"
            width="270px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="edit(scope.$index, scope.row)">编辑</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="del(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>

        </el-table>
      </template>
    </div>

    <div class="row">
      <el-pagination
        @size-change="process"
        @current-change="process"
        :current-page.sync="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>


    <!-- new form-->
    <div class="row">
      <el-dialog :title="form.tradeId == 0 ? '新增trade':'修改trade'" :visible.sync="form.dialogFormVisible" @close="close">

        <input hidden v-model="form.tradeId">

        <el-form :model="form" ref="form" label-width="100px" class="demo-ruleForm"
                 :rules="{tradeName:[{required:true,message:'请输入名称',trigger:'blur'}],priority:[{required:true,message:'请输入显示优先级'}]}" action="/trade/addOrEdit">
          <el-form-item label="Name" prop="tradeName">
            <el-input v-model="form.tradeName"></el-input>
          </el-form-item>

          <el-form-item label="Priority" prop="priority">
            <el-input-number v-model="form.priority" :min="-99999" :max="99999" :step="50"></el-input-number>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="form.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </div>
      </el-dialog>
    </div>


  </div>
</template>

<script>
  export default {
    name: "Trade",
    data: function () {
      return {
        filter: {
          orderField: "",
        },
        records: [],
        total: 0,
        page: {
          pageSize: 10,
          currentPage: 1
        },
        form: {
          tradeName: '',
          tradeId:null,
          labelWidth: '120px',
          dialogFormVisible: false,
        }
      };
    },
    created: function () {
      this.process();
    },
    methods: {
      close:function () {
        this.form.tradeId = null;
        this.form.tradeName = "";
      },
      sortChange(column){
        if(!column || !column.order){
          this.filter.orderField = "";
          this.process();
          return ;
        }
        this.filter.orderField =  column.order.toLowerCase() === "ascending" ? column.prop + " asc" : column.prop + " desc";
        this.process();
      },
      process: function () {
        this.$http.post("/trade/list", {
          filter: this.filter,
          pageSize: this.page.pageSize,
          currentPage: this.page.currentPage
        }).then(response => {
          this.records = response.data.data.data;
          this.total = response.data.data.total;
        });
      },
      submit: function () {
        this.$refs.form.validate(
          validate => {
            if (!validate) {
              return false;
            }
            this.$http.post(this.$refs['form'].$attrs.action, {
              tradeName: this.form.tradeName,
              tradeId:this.form.tradeId,
              priority:this.form.priority
            }).then(response => {
              if (response.data.code == "1") {
                this.form.dialogFormVisible = false;
                this.$message.success("操作成功");
                this.process();
                return true;
              }
            });
          }
        );
      },
      edit:function (index,row) {
        this.form.tradeId = row.tradeId;
        this.form.tradeName = row.tradeName;
        this.form.priority = row.priority;
        this.form.dialogFormVisible =true;
      },
      del:function (index,row) {
        this.$confirm('确定删除该记录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          this.$http.post("/trade/delete",{
            tradeId: row.tradeId,
          }).then(response=>{
            if(response.data.code == "1"){
              this.$message.success("删除成功");
              this.process();
            }
          })
        });

      }
    }
  }
</script>

<style scoped>

  .filter {
    border: 1px solid #DCDFE6;
  }

  .filter > .filter-item {
    border-bottom: 1px dashed #DCDFE6;
    position: relative;
    display: block;
    padding: 5px 0 5px 0;
  }

  .filter > .filter-item:last-of-type {
    border-bottom: none;
  }

  .filter > .filter-item > .item-head {
    display: inline-block;
    width: 150px;
    float: left;
    line-height: 32px;
    padding-left: 10px;
  }

  .filter > .filter-item > .item-content {
    display: block;
    float: left;
    margin-left: 10px;
  }

  .clear {
    display: block;
    overflow: hidden;
  }


</style>



// WEBPACK FOOTER //
// src/components/item/Trade.vue